var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStarReview(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.24884 1.3403C7.58855 0.523531 8.74559 0.52353 9.0853 1.3403L10.6628 5.13316L14.7576 5.46143C15.6393 5.53212 15.9969 6.63253 15.3251 7.20801L12.2053 9.8804L13.1584 13.8761C13.3637 14.7366 12.4276 15.4167 11.6727 14.9556L8.16707 12.8144L4.66142 14.9556C3.90651 15.4167 2.97044 14.7366 3.17569 13.8761L4.12882 9.8804L1.00908 7.20801C0.337268 6.63253 0.69481 5.53212 1.57658 5.46143L5.6713 5.13316L7.24884 1.3403Z",
    fill: "#FFA800"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarReview);
export default __webpack_public_path__ + "static/media/starReview.04eca8ae34febde1ac39e7e8d3b0d74b.svg";
export { ForwardRef as ReactComponent };